import { useEffect, useState } from "react";
import api from "@/lib/api";

/** Admin card: which countries see the maintenance screen, and which IPs
 *  (single addresses or CIDR ranges) always bypass the block. */
export function AccessControlCard() {
  const [countries, setCountries] = useState("");
  const [ips, setIps] = useState("");
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    api.get("/access/config").then(({ data }) => {
      setCountries((data.blocked_countries || []).join(", "));
      setIps((data.allow_ips || []).join(", "));
    });
  }, []);

  async function save() {
    setSaving(true);
    setStatus("");
    try {
      const { data } = await api.put("/access/config", {
        blocked_countries: countries.split(",").map((s) => s.trim()).filter(Boolean),
        allow_ips: ips.split(",").map((s) => s.trim()).filter(Boolean),
      });
      setCountries((data.blocked_countries || []).join(", "));
      setIps((data.allow_ips || []).join(", "));
      setStatus("Saved.");
    } catch {
      setStatus("Could not save — please try again.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="bg-white border border-[#E5E5E5] p-8" data-testid="settings-access-card">
      <div className="gv-label">Access · Region block</div>
      <h3 className="font-serif text-2xl mt-2 text-[#1A1F24] mb-2">Who can see the site</h3>
      <p className="text-sm text-[#5C6670] mb-6">
        Visitors from these countries see a maintenance screen instead of the site. Your own
        networks below always get through, and you&apos;re never blocked while signed in here.
      </p>

      <div className="space-y-5">
        <div>
          <label className="gv-label">Blocked country codes (comma separated)</label>
          <input
            type="text"
            className="gv-input mt-2"
            value={countries}
            onChange={(e) => setCountries(e.target.value)}
            placeholder="AE, DE, ZA, IN"
            data-testid="access-blocked-countries-input"
          />
        </div>
        <div>
          <label className="gv-label">Always-allowed IPs / ranges</label>
          <input
            type="text"
            className="gv-input mt-2"
            value={ips}
            onChange={(e) => setIps(e.target.value)}
            placeholder="106.222.234.234, 106.222.224.0/19"
            data-testid="access-allow-ips-input"
          />
        </div>
      </div>

      <div className="mt-6 flex items-center justify-end gap-4">
        {status && (
          <span className="text-xs text-[#5C6670]" data-testid="access-save-status">
            {status}
          </span>
        )}
        <button
          onClick={save}
          disabled={saving}
          className="gv-btn-gold"
          data-testid="access-save-btn"
        >
          {saving ? "Saving…" : "Save changes"}
        </button>
      </div>
    </div>
  );
}
